// @flow

import { ChartModel } from './chart.model';

export class BaseRenderer {
    canvas: HTMLCanvasElement;
    context: CanvasRenderingContext2D;
    chart: ChartModel;
    progressAnimation: boolean;
    animations: any;
    constructor (chart: ChartModel, width: number, height: number) {
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');
        this.chart = chart;
        this.canvas.width = width;
        this.canvas.height = height;
        this.animations = {};
    }

    render () {
    }

    draw () {
        if (this.progressAnimation) {
            this.render();
        }
        return this.canvas;
    }

    update (changes: any) {
        this.progressAnimation = true;
    }

    clear () {
        const { width, height } = this.canvas;
        this.context.clearRect(0, 0, width, height);
    }
}
